import IProductGetSingle from 'api/interfaces/products/IProductGetSingle';
import IProductPost from 'api/interfaces/products/IProductPost';

const text = (value: null | number | string | undefined): string =>
  value === null || value === undefined ? '' : String(value).trim();

const number = (value: null | number | string | undefined): number =>
  Number(text(value).replace(',', '.')) || 0;

// The rows of a list in an order of their own, so that only their content counts
const sorted = (rows: string[]): string => JSON.stringify([...rows].sort());

const contentOf = (product: {
  attributes?: { type: string; value: number | string }[];
  categories?: string[];
  deliveryCategory?: string;
  displayName?: string;
  measurements?: { siUnit: string; type: string; value: number | string }[];
  memo?: null | string;
  name?: string;
  prices?: {
    siUnit: string;
    type: string;
    useInOffers?: boolean;
    value: number | string;
  }[];
  productIds?: { type: string; value: string }[];
  supplierId: null | number | undefined;
  supplierProductName?: string;
  tags?: string[];
}): string =>
  JSON.stringify([
    text(product.name),
    text(product.displayName),
    text(product.supplierProductName),
    text(product.memo),
    product.supplierId ?? null,
    text(product.deliveryCategory),
    sorted(product.categories ?? []),
    sorted(product.tags ?? []),
    sorted(
      (product.productIds ?? [])
        .filter((id) => text(id.value) !== '')
        .map((id) => `${id.type}=${text(id.value)}`)
    ),
    sorted(
      (product.attributes ?? []).map(
        (attribute) => `${attribute.type}=${text(attribute.value)}`
      )
    ),
    sorted(
      (product.measurements ?? []).map(
        (measurement) =>
          `${measurement.type}=${number(measurement.value)}${
            measurement.siUnit
          }`
      )
    ),
    sorted(
      (product.prices ?? []).map(
        (price) =>
          `${price.type}=${number(price.value)}${price.siUnit}${
            price.useInOffers ? '*' : ''
          }`
      )
    ),
  ]);

/**
 * Whether a product made from a copy is still the same as the product it was copied from:
 * a copy is saved only when something of it was changed. The files are not compared, as
 * they are not copied.
 */
const isSameProduct = (
  post: IProductPost,
  source: IProductGetSingle
): boolean =>
  contentOf(post) ===
  contentOf({ ...source, supplierId: source.supplier?.id ?? null });

export default isSameProduct;
